export enum ImageType {
  IMAGE = 'IM',
  DRAW = 'DR'
}
